import React, { useState,useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import { var_api } from '../constant.js';
import "./currency_master.css";

function PaymentCredentials(){
    const history = useHistory();
    const shopName= localStorage.getItem('shopName');
    const [credentials, setCredentials] = useState("");
    const [ loading, setLoading ] = useState(false);
    const [ searchQuery,setSearchQuery] = useState('');

    //redirect to home page
    const handleHome = () =>{
      history.push('/AdminDashboard')
    }

    //list the catgories in select
    useEffect(() => {
        fetchCredentails();
    
    }, []);


//fetch the uom details
    const fetchCredentails = async () => {
        setLoading(true);

        const shopId = localStorage.getItem('shopId');
       try {
        const response = await axios.get(`${var_api}/api/payment-credential/get-credential` );
        const use = response.data
      setCredentials(use);
      
      console.log("categories",credentials)
      setLoading(false);
      }catch (error) {
        console.log('Error fetching data:', error);
        
        }
      };

 




      

      //to open the form for slot updation 
    const handleEditCredentials = async () => {
        const { value: formValues } = await Swal.fire({
            title: 'Update Currrency',
            html: `
             <label class="swalLa">Key ID</label>
             <br/>
              <input id="swal-input1" class="swal2-input fin" name="key_id" placeholder="key ID" value="${credentials.key_id || ''}">
              <br/>
              <br/>
              <label class="swalLa">Key Secret</label>
              <input id="swal-input2" class="swal2-input fin" name="key_secret" placeholder="Key secret" value="${credentials.key_secret || ''}">
             
            `,
            focusConfirm: false,
            showCancelButton: true,
            confirmButtonColor: '#007500',
            confirmButtonText: 'Submit',
            preConfirm: () => {
              return new Promise(async (resolve) => {
                const input1 = document.getElementById('swal-input1').value;
                const input2 = document.getElementById('swal-input2').value;
        
                if (!input1 || !input2) {
                  Swal.showValidationMessage('Please fill in all the required fields');
                  resolve(null);
                } else {

                  const requestData = {
                    key_id: input1 || credentials.key_id,
                    key_secret: input2 || credentials.key_secret
                  };
        
                  try {
                    // Make a PUT request to update the UOM
                    const response = await axios.put(`${var_api}/api/payment-credential/put/${credentials.id}`, requestData, {
                      headers: {
                        'Content-Type': ' application/json', 
                      },
                    });
        
                    if (response.status === 200) {
                        fetchCredentails();
                      // Category updated successfully
                      Swal.fire({
                        icon: 'success',
                        text: 'Credentials updated successfully',
                        confirmButtonColor: '#007500',
                      });
                    } else {
                      Swal.fire({
                        icon: 'error',
                        text: 'Failed to update Credentials',
                        confirmButtonColor: '#007500',
                      });
                    }
                  } catch (error) {
                    console.error('Error updating Credentials:', error);
                    Swal.fire('Error', 'Failed to update Credentials. Please try again.', 'error');
                  }
        
                  resolve(requestData);
                }
              });
            },
          });
      };




    return(
        <>
        <nav className="navbar navbar-expand navbar-light py-2 sticky-top" style={{boxShadow: "0px 0px 1px 0px black",backgroundColor:"green",border:"none"}} >
          <h5 className="hefou" style={{textAlign:"center",color:"white",paddingLeft:"5px"}}><i class="bi bi-arrow-left-circle" onClick={handleHome} style={{fontSize:"21px"}}></i>{' '}Payment Gateway Credentials</h5>
        </nav>
        <br/>
        <br/>
        <br/>
        <br/>
        <div id='dailybacku'>
          <br/>
          <br/>
          <div id='fiboxu'>
          
            <div class="labelsu">
            <i class="bi bi-pencil-square" onClick={handleEditCredentials}  style={{fontSize:"20px",color:"rgb(9, 97, 9)",float:"right",margin:"0px 15px 0px 15px"}}></i>
            <br/>
            <lable style={{color:"green",fontWeight:"bold",fontSize:"18px",letterSpacing:"2px"}}>Key ID  </lable>
            <input  className="form-inputu" type='text' name='currency_name'
             required
             value={credentials.key_id}
            />
            </div>
            <br/>
            <div class="labelsu">
            <lable style={{color:"green",fontWeight:"bold",fontSize:"18px",letterSpacing:"2px"}}>Key Secret</lable>
            <input  className="form-input1u" type='text' name='currency_description'
            required
             value={credentials.key_secret}/>
            </div>
           
           
          </div>
          
        </div>
        </>
    )
}

export default PaymentCredentials;